export function getManualFileName(): string {
  const hostname = window.location.hostname;

  const match = hostname.match(/gdu(?:webvm)?(\d+)/i);

  if (match) {
    const number = match[1].padStart(2, "0");
    return `manual_usuario_GDUWEBVM${number}.pdf`;
  }

  return "manual_usuario_GDUWEBVM01.pdf";
}